<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 122 89"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <g id="_494187288">
     <path class="fil0" d="M20 30l0 2c-2,0 -6,2 -8,3 -4,3 -8,7 -10,12 -4,9 -2,18 4,25 7,8 15,8 26,8l0 -7c-7,0 -12,1 -18,-3l-3 -3c-3,-4 -4,-6 -4,-12 0,-5 3,-10 6,-13 2,-1 4,-2 7,-3 2,0 5,0 8,0 0,-3 -1,-6 -1,-9 0,-9 5,-17 13,-20 8,-5 16,-4 24,1 2,2 7,7 7,10 3,0 8,-4 15,0 7,3 9,8 9,15 9,0 16,5 19,13 2,8 -1,16 -7,21 -2,1 -5,2 -8,3 -3,1 -9,-1 -9,1 0,8 -1,6 4,6 7,0 14,-1 19,-7 3,-3 4,-3 6,-7 7,-14 -1,-32 -18,-36 0,-3 -2,-6 -3,-8 -1,-1 -1,-1 -1,-2l-3 -2c-4,-4 -8,-6 -14,-6 -2,0 -4,0 -6,0 -8,-13 -28,-16 -41,-6 -2,1 -2,1 -4,2l0 1c-5,5 -9,12 -9,21z"/>
     <path class="fil0" d="M41 63c0,-11 9,-19 20,-19 17,0 26,20 13,33 -12,12 -33,3 -33,-14zm-7 -1c0,11 6,20 15,25 13,6 29,1 36,-13 8,-17 -6,-37 -23,-37 -7,0 -10,1 -15,3 -6,4 -13,13 -13,22z"/>
     <path class="fil1" d="M50 56c0,1 3,3 4,4 0,0 3,3 3,3l-7 7c0,0 4,3 4,4 0,-1 1,-2 2,-2 1,-1 4,-5 5,-5 0,0 1,1 2,1 0,1 1,2 1,2l4 4c0,-1 3,-4 3,-4l-7 -7c1,0 6,-6 7,-7 0,0 -3,-3 -3,-3l-7 6c-1,0 -5,-4 -5,-5 -1,0 -2,-1 -2,-1l-4 3z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'ConnectionFail',
};
</script>

<style scoped>
  .fil0 {fill:#666666}
  .fil1 {fill:red}
</style>
